module.exports = __webpack_public_path__ + "static/media/tankTrailer_blue.33ede668.svg";